<template>
  <div class="list-card-popup">
    <PopUp
      :title="title"
      :pop-up-active="popupActive"
      @click="$_popupClose()"
    >
      <ListCard
        no-padding
        white
        is-table
      >
        <ListCardItem
          v-for="(field_e,field_k) in fields"
          :key="field_k"
          is-table
          row
          :type="field_e.type"
          :title="field_e.title"
          :time="fieldData[field_k].time"
          :avatar-image="fieldData[field_k].avatarImage"
          :avatar-name="fieldData[field_k].name"
          :leading-icon="fieldData[field_k].leadingIcon"
          :text-content="$_getTextContent(fieldData[field_k])"
          :valid-start="fieldData[field_k].validStart"
          :valid-end="fieldData[field_k].validEnd"
        />
      </ListCard>
      <div class="one-bottom-btn">
        <WsButton001
          :to="to"
          width-stretch
          @click="$_btnClick()"
        >
          {{ $t('查看詳細資料') }}
        </WsButton001>
      </div>
    </PopUp>
  </div>
</template>
<script>
export default {
  name: "ListCardPopup",
  props: {
    popupActive: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    fields: {
      type: Object,
      default() {
        return {};
      },
    },
    fieldData: {
      type: Object,
      default() {
        return {};
      },
    },
    to: {
      type: String,
      default: "",
    },
  },
  data: () => ({}),
  methods: {
    $_popupClose() {
      this.$emit("popup-close");
    },
    $_btnClick() {
      this.$emit("btn-click");
    },
    $_getTextContent(data) {
      return data.text ? data.text : data.name ? data.name : "";
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/list-card-popup";
</style>